import {ValidationMessage} from "../validation/validation.service";
import {HttpErrorResponse} from "@angular/common/http";

export interface DisplayableDataServerMessage {
    readonly messageKey: string;
    readonly messageParams: any;
}

export interface DataServerConditionNotification {
    readonly conditionName: string;
    readonly conditionParams: any;
}

export class DataClientError {
    private _message: string;
    private _validationMessages: ValidationMessage[];
    private _displayableMessage: DisplayableDataServerMessage;
    private _conditionNotification: DataServerConditionNotification;
    private resolveIdentified: (value?: (PromiseLike<void> | void)) => void;
    private identified: Promise<void> = new Promise<void>(resolve => this.resolveIdentified = resolve);

    constructor(public response: HttpErrorResponse, requestedResponseType: "json" | "blob" | "text") {
        if (response.error instanceof Error) {
            this._message = response.error.message;
        } else if (response.error instanceof Blob) {
            if (requestedResponseType === "blob") {
                this.parseErrorText(response.error.text());
            } else {
                this._message = response.message;
                this.resolveIdentified();
            }
        } else if (typeof response.error === "string") {
            if (requestedResponseType === "text") {
                this.parseErrorText(Promise.resolve(response.error));
            } else {
                this._message = response.error;
                this.resolveIdentified();
            }
        } else {
            this.identifyErrorObject(response.error)
        }
    }

    private async parseErrorText(errorTextPromise: Promise<string>): Promise<void> {
        const errorText: string = await errorTextPromise;
        try {
            this.identifyErrorObject(JSON.parse(errorText));
        } catch (e) {
            this._message = errorText;
            this.resolveIdentified();
        }
    }

    private identifyErrorObject(errorObject: any): void {
        if (errorObject) {
            if (this.response.status === 422) {
                this._validationMessages = errorObject;
            } else if (errorObject["messageKey"]) {
                this._displayableMessage = errorObject;
            } else if (errorObject["conditionName"]) {
                this._conditionNotification = errorObject;
            } else {
                console.log("Unexpected error object:", errorObject)
                this._message = JSON.stringify(errorObject);
            }
        }
        this.resolveIdentified();
    }

    get status(): number {
        return this.response.status;
    }

    get message(): Promise<string> {
        return (async () => {
            await this.identified;
            return this._message;
        })();
    }

    set message(message: string) {
        this._message = message;
    }

    get validationMessages(): Promise<ValidationMessage[]> {
        return (async () => {
            await this.identified;
            return this._validationMessages;
        })();
    }

    get displayableMessage(): Promise<DisplayableDataServerMessage> {
        return (async () => {
            await this.identified;
            return this._displayableMessage;
        })();
    }

    get conditionNotification(): Promise<DataServerConditionNotification> {
        return (async () => {
            await this.identified;
            return this._conditionNotification;
        })();
    }
}
